// extracted by mini-css-extract-plugin
export var actionText = "_se-4";
export var container = "_se-0";
export var leftSection = "_se-1";
export var rightSection = "_se-2";
export var settingsButton = "_se-6";
export var settingsIcon = "_se-7";
export var shortcut = "_se-5";
export var shortcutGroup = "_se-3";